import type { RoleAllocationSlice } from "@/domain/clients/types";

export type { RoleAllocationSlice };

export function mergeRoleDistributions(
  parts: ReadonlyArray<readonly RoleAllocationSlice[]>,
): RoleAllocationSlice[] | null {
  const totals = new Map<string | null, { color: string; value: number }>();
  let total = 0;
  for (const slices of parts) {
    for (const s of slices) {
      const hit = totals.get(s.label);
      if (hit) hit.value += s.value;
      else totals.set(s.label, { color: s.color, value: s.value });
      total += s.value;
    }
  }
  if (total <= 0) return null;
  return [...totals.entries()]
    .filter(([, agg]) => agg.value > 0)
    .sort((a, b) => b[1].value - a[1].value)
    .map(([label, agg]) => ({
      label,
      color: agg.color,
      value: agg.value,
      pct: (agg.value / total) * 100,
    }));
}

export function roleColor(label: string | null): string {
  if (label) {
    for (const { match, color } of ROLE_COLORS) {
      if (match.test(label)) return color;
    }
  }
  return FALLBACK_COLOR;
}

const ROLE_COLORS: ReadonlyArray<{ match: RegExp; color: string }> = [
  { match: /^avkastning/i, color: "#5F54EB" },
  { match: /^riskspridare/i, color: "#9F89F0" },
  { match: /^defensiv/i, color: "#D0C1F4" },
];

const FALLBACK_COLOR = "#B3B3AE";
